<template>
    <div class="column_center_around order_method_container">
        <span class="button-icon text-6xl h-16 mb-2 text-[#FBCB02]">lock_clock</span>
        <p class="text-base font-medium">LINE下單暫停接單中</p>
    </div>
</template>
<script>
export default {
};
</script>
<style lang="scss" scoped></style>